import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'kit-bootstrap-progress-example',
  templateUrl: './progress.component.html',
})
export class KitBootstrapProgressExampleComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
